import apiClient from "services/axios";

const API = {
  healthCheck: "api/health-check",
};

export const healthCheck = async () => {
  const response = await apiClient.get(`${API.healthCheck}`);
  if (response) {
    return response.data;
  }
  return false;
};
